import {
  INVOICE_BATCH_BILLING_CHECKLIST_REQUEST,
  INVOICE_BATCH_BILLING_CHECKLIST_RECEIVED,
  INVOICE_BATCH_BILLING_CHECKLIST_ERROR,
  INVOICE_BATCH_BILLING_CHECKLIST_UNLOAD,
  INVOICE_BATCH_BILLING_CHECKLIST_SET_DATE,
  BILLING_CHECKLIST_SET_FILTER_TEXT,
} from '../constants';

const reducer = (
  state = {
    checklistInvoiceBatches: [],
    isFetchingChecklistInvoicesBatches: false,
    currentDate: undefined,
    filterText: '',
  },
  action,
) => {
  switch (action.type) {
    case INVOICE_BATCH_BILLING_CHECKLIST_REQUEST:
      return {
        ...state,
        isFetchingChecklistInvoicesBatches: true,
      };

    case INVOICE_BATCH_BILLING_CHECKLIST_RECEIVED:
      return {
        ...state,
        checklistInvoiceBatches: action.data,
        isFetchingChecklistInvoicesBatches: false,
      };

    case INVOICE_BATCH_BILLING_CHECKLIST_ERROR:
      return {
        ...state,
        isFetchingChecklistInvoicesBatches: false,
      };

    case INVOICE_BATCH_BILLING_CHECKLIST_UNLOAD:
      return {
        checklistInvoiceBatches: [],
        isFetchingChecklistInvoicesBatches: false,
        currentDate: undefined,
      };

    case INVOICE_BATCH_BILLING_CHECKLIST_SET_DATE:
      return {
        ...state,
        currentDate: action.date,
      };

    case BILLING_CHECKLIST_SET_FILTER_TEXT:
      return {
        ...state,
        filterText: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
